/**
 * Created by Ning Jiang on 2/7/2019.
 */

import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {
    IndividualWinPresentationController
} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {GameTweakerTest} from "@nolimitcity/slot-game/bin/dev/tweaker/test/GameTweakerTest";
import {StillImageBackground} from "@nolimitcity/slot-game/bin/game/background/StillImageBackground";
import {SpacierArcadeFontConfig} from "./SpacierArcadeFontConfig";
import {SpacierArcadeGameAssets} from "./SpacierArcadeGameAssets";
import {SpacierArcadeGameConfig} from "./SpacierArcadeGameConfig";
import {SpacierArcadeSoundConfig} from "./SpacierArcadeSoundConfig";
import {SpacierArcadeServerDataParser} from "./server/SpacierArcadeServerDataParser";
import {SpacierArcadeParsedGameData} from "./server/data/SpacierArcadeParsedGameData";
import {SpacierArcadeParsedInitData} from "./server/data/SpacierArcadeParsedInitData";
import {SASymbols, SpacierArcadeReelSymbol} from "./symbols/SpacierArcadeReelSymbol";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {AAFreespinIntroView} from "./screens/freeSpinIntro/AAFreespinIntroView";
import {AAFreespinOutroView} from "./screens/freeSpinOutro/AAFreespinOutroView";
import {SpacierArcadeOverlayView} from "./features/overlay/SpacierArcadeOverlayView";
import {SAReelController} from "./reel/SAReelController";
import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {SpacierArcadeWildSymbol} from "./symbols/SpacierArcadeWildSymbol";
import {SpacierArcadeScatterSymbol} from "./symbols/SpacierArcadeScatterSymbol";
import {SABackground} from "./background/SABackground";
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {SAReelAreaView} from "./reel/SAReelAreaView";
import {SAReelView} from "./reel/SAReelView";
import {SAMultiplierAddupController} from "./winpresentation/multiplieraddup/SAMultiplierAddupController";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {SALayerConfig} from "../config/SALayerConfig";
import {SATransitionController} from "./screens/SATransitionController";
import {SpinStart} from "./gameround/SpinStart";
import {ReelStart} from "./gameround/ReelStart";
import {SpinStop} from "./gameround/SpinStop";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {BigWinStep} from "./gameround/bigWin/BigWinStep";
import {WinEnd} from "./gameround/WinEnd";
import {ReelStopPresentations} from "./gameround/ReelStopPresentations";
import {SAReelAttentionView} from "./reelstoppresentation/SAReelAttentionView";
import {SAScatterAttentionView} from "./reelstoppresentation/SAScatterAttentionView";
import {ScatterReelAttention} from "./gameround/ScatterReelAttention";
import {SpacierArcadeInitialWinCountUp} from "./winpresentation/initial/SpacierArcadeInitialWinCountUp";
import {BetWayWin} from "./gameround/BetWayWin";
import {SAIndividualWinCountUp} from "./winpresentation/individual/SAIndividualWinCountUp";
import {SymbolOverlays} from "./gameround/SymbolOverlays";
import {SpacierArcadeGameMode} from "./gamemode/SpacierArcadeGameMode";
import {SAOverlayPresentation} from "./winpresentation/SAOverlayPresentation";
import {WinTextView} from "./gameround/WinTextView";
import {CountUpView} from "./gameround/CountUpView";
import {GameRestoreHandling} from "./gameround/GameRestoreHandling";
import {ScatterRetrigger} from "./gameround/ScatterRetrigger";
import {ReelPartAnimator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartAnimator";
import {SAReelPartAnimator} from "./reel/SAReelPartAnimator";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {TimelineReelsController} from "@nolimitcity/slot-game/bin/timelinegameround/reels/TimelineReelsController";
import {FreespinZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/FreespinZeroBetController";
import {
    NoWinSymbolsWinPresentationController
} from "@nolimitcity/slot-game/bin/game/winpresentation/nowinsymbols/NoWinSymbolsWinPresentationController";
import {
    BetWayWinIndividualWPController
} from "@nolimitcity/slot-game/bin/game/winpresentation/individualwin/BetWayWinIndividualWPController";
import {
    GameModeTransitionController
} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionController";
import {GameRoundConfig} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundManager";
import {ZeroBet} from "@nolimitcity/slot-game/bin/timelinegameround/game/gameround/presentations/ZeroBet";
import {ReelStop} from "./gameround/ReelStop";
import {FreeSpinWildAttention} from "./gameround/FreeSpinWildAttention";
import {SAFreespinReelAttentionView} from "./reelstoppresentation/SAFreespinReelAttentionView";
import {NormalWin} from "./gameround/NormalWin";
import {SAInitialWinPresentation} from "./winpresentation/initial/SAInitialWinPresentation";
import {FreespinSpinStart} from "./gameround/FreespinSpinStart";
import {SAZeroBet} from "./gameround/SAZeroBet";
import {SARespinTransitionContorller} from "./screens/SARespinTransitionContorller";
import {Idle} from "./gameround/Idle";
import {FSProlongSpin} from "./gameround/FSProlongSpin";
import {FeaturePrice} from "./utils/FeaturePrice";
import {BetWayWinUS} from "./gameround/BetWayWinUS";

export class SpacierArcadeGameModuleConfig implements IGameModuleConfig {


    GAME_CONFIG: IGameConfig = SpacierArcadeGameConfig.instance;
    SOUND_CONFIG: ISoundConfig = SpacierArcadeSoundConfig.instance;

    FONTS_CONFIG: IFontsConfig = SpacierArcadeFontConfig.FONTS;
    RESOURCES_CONFIG: IResourcesGroupConfig = SpacierArcadeGameAssets.RESOURCES_GROUPS;

    constructor() {
        if (SpacierArcadeGameModuleConfig.instance) {
            throw new Error("SpacierArcadeGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
    }

    REEL_AREA_VIEW: () => ReelAreaView = () => {
        return new SAReelAreaView();
    };

    REEL_CONTROLLER:(reelId:number) => ReelController = reelId => new SAReelController(reelId);

    REELS?:() => Reels = ()=>{
        return new TimelineReelsController();
    };

    REEL_VIEW?:(reelId:number) => PIXI.Container = reelId => {
        return new SAReelView(reelId);
    };

    REEL_PART_ANIMATOR: (callbacks: any) => ReelPartAnimator = (callbacks: any) => {
        return new SAReelPartAnimator(callbacks);
    };

    SERVER_PARSER: () => ServerDataParser = () => {
        return new SpacierArcadeServerDataParser();
    };

    PARSED_INIT_DATA: (data: any, dataParser: ServerDataParser) => ParsedInitData = (data, dataParser: ServerDataParser) => {
        return new SpacierArcadeParsedInitData(data, <SpacierArcadeServerDataParser>dataParser);
    };

    PARSED_GAME_DATA: (data: any, dataParser: ServerDataParser) => ParsedGameData = (data, dataParser: ServerDataParser) => {
        return new SpacierArcadeParsedGameData(data, <SpacierArcadeServerDataParser>dataParser);
    };

    // SCREENS:(() => ScreenController)[] = [];

    REEL_PART_CREATOR: () => ReelPartCreator = () => {
        return new ReelPartCreator(
            (symName: string, reelId: number, state?: ISymbolStateConfig): SpacierArcadeReelSymbol => {
                if(symName == SASymbols.W ) {
                    return new SpacierArcadeWildSymbol(symName, reelId, state);
                }
                else if(symName == SASymbols.S) {
                    return new SpacierArcadeScatterSymbol(symName, reelId, state);
                }
                return new SpacierArcadeReelSymbol(symName, reelId, state);
            });
    };

    ZERO_BETS:(() => ZeroBetController)[] = [
        () => {
            return new FreespinZeroBetController();
        }
    ];

    WIN_PRESENTATIONS:((indexes:[number, number]) => WinPresentationController)[][] = [
        [indexes => {
            return new NoWinSymbolsWinPresentationController(indexes, {noWinStateFadeInDuration : 1});
        }]
    ];

    INDIVIDUAL_WIN_PRESENTATION:() => IndividualWinPresentationController = () => {
        return new BetWayWinIndividualWPController({
            symbolTimeOffsetCalculator : (currentTotalDuration:number, reelId:number, symbolId:number):number => {
                return 0;
            }
        });
    };

    // INTRO_VIEW: (onClickCallback: () => void) => SpacierArcadeIntroView =
    //     (onClickCallback: () => void) => new SpacierArcadeIntroView({
    //         layer: SpacierArcadeGameConfig.instance.LAYERS.INTRO.name,
    //         onButtonClickCallback: onClickCallback,
    //         resourceGroup: ResourcesGroupName.INTRO,
    //         backgroundTextures: {
    //             desktop: {landscape: SpacierArcadeGameAssets.INTRO_BACKGROUND},
    //         }
    //     });


    // WIN_FIELD:() => WinField = () => {
    //     return new KeypadWinField();
    // };

    GAME_MODE_TRANSITIONS?:(() => GameModeTransitionController)[] = [
        () => {
            return new SARespinTransitionContorller(GameMode.NORMAL, SpacierArcadeGameMode.RESPIN);
        },
        () => {
            return new GameModeTransitionController(SpacierArcadeGameMode.RESPIN, SpacierArcadeGameMode.RESPIN);
        },
        () => {
            return new SARespinTransitionContorller(SpacierArcadeGameMode.RESPIN, GameMode.NORMAL);
        },
        () => {
            return new SATransitionController(
                GameMode.NORMAL,
                GameMode.FREESPIN,
                new AAFreespinIntroView(StageManager.getLayer(SALayerConfig.FS_INTRO.name))
            );
        },
        () => {
            return new SATransitionController(
                SpacierArcadeGameMode.RESPIN,
                GameMode.FREESPIN,
                new AAFreespinIntroView(StageManager.getLayer(SALayerConfig.FS_INTRO.name))
            );
        },
        () => {
            return new SATransitionController(
                GameMode.NORMAL,
                GameMode.FREESPIN_RESPIN,
                new AAFreespinIntroView(StageManager.getLayer(SALayerConfig.FS_INTRO.name))
            );
        },
        () => {
            return new GameModeTransitionController(GameMode.FREESPIN, SpacierArcadeGameMode.FREESPIN_RESPIN);
        },
        () => {
            return new GameModeTransitionController(SpacierArcadeGameMode.FREESPIN_RESPIN, SpacierArcadeGameMode.FREESPIN_RESPIN);
        },
        () => {
            return new GameModeTransitionController(SpacierArcadeGameMode.FREESPIN_RESPIN, GameMode.FREESPIN);
        },
        () => {
            return new SATransitionController(
                SpacierArcadeGameMode.FREESPIN_RESPIN,
                GameMode.NORMAL,
                new AAFreespinOutroView(StageManager.getLayer(SALayerConfig.FS_OUTRO.name))
            );
        },
        () => {
            return new SATransitionController(
                GameMode.FREESPIN,
                GameMode.NORMAL,
                new AAFreespinOutroView(StageManager.getLayer(SALayerConfig.FS_OUTRO.name))
            );
        }
    ];



    GAME_ROUND_CONFIG:() => GameRoundConfig = () => {
        return {
            NORMAL : {
                idle : [
                    new Idle()
                ],
                idleLoop : [
                    new BetWayWin()
                ],
                starting : [
                    new SpinStart(),
                    new ReelStart(0, 0),
                    new ReelStart(1, 0.04),
                    new ReelStart(2, 0.08),
                    new ReelStart(3, 0.12),
                    new ReelStart(4, 0.16)
                ],
                stoppable : [
                    new ReelStopPresentations(0),
                    new SymbolOverlays(0),

                    new ReelStopPresentations(1),
                    // new ScatterAttention(1),
                    new SymbolOverlays(1),

                    new ReelStopPresentations(2),
                    // new ScatterAttention(2),
                    new SymbolOverlays(2),

                    new ScatterReelAttention(3, 1.5, 1),
                    new ReelStopPresentations(3),
                    // new ScatterAttention(3),
                    new SymbolOverlays(3),

                    new ReelStopPresentations(4 ),
                    new SpinStop()
                ],
                skippable : [
                    [
                        new SAOverlayPresentation(),
                        new NormalWin(),
                        new BigWinStep(GameConfig.instance.WIN_RATIOS.normalWin[0], GameConfig.instance.WIN_RATIOS.bigWin[0], true, SpacierArcadeSoundConfig.instance.BIG_WIN_LEVEL1)
                    ],
                    [
                        new BigWinStep(GameConfig.instance.WIN_RATIOS.bigWin[0], GameConfig.instance.WIN_RATIOS.bigWin[1], false, SpacierArcadeSoundConfig.instance.BIG_WIN_LEVEL2)
                    ],
                    [
                        new BigWinStep(GameConfig.instance.WIN_RATIOS.bigWin[1], GameConfig.instance.WIN_RATIOS.bigWin[2], false, SpacierArcadeSoundConfig.instance.BIG_WIN_LEVEL3)
                    ],
                    [
                        new WinEnd(),
                    ],
                    [
                        new BetWayWinUS(),
                    ]
                ]

            },
            WILD_RESPIN : {
                idle : [
                    new ZeroBet()
                ],
                idleLoop : [
                    new BetWayWin()
                ],
                starting : [
                    new GameRestoreHandling(),
                    new SpinStart(),
                    new ReelStart(2, 0),
                    new ReelStart(1, 0),
                    new ReelStart(3, 0),
                    new ReelStart(0, 0),
                    new ReelStart(4, 0),
                ],
                stoppable : [
                    new ReelStopPresentations(0),
                    new SymbolOverlays(0),

                    new ReelStopPresentations(1),
                    new SymbolOverlays(1),

                    new ReelStopPresentations(2),
                    new SymbolOverlays(2),

                    new ReelStopPresentations(3),
                    new SymbolOverlays(3),

                    new ReelStopPresentations(4),
                    new SpinStop()
                ],
                skippable : [
                    [
                        new SAOverlayPresentation(),
                        new NormalWin(),
                        new BigWinStep(GameConfig.instance.WIN_RATIOS.normalWin[0], GameConfig.instance.WIN_RATIOS.bigWin[0], true, SpacierArcadeSoundConfig.instance.BIG_WIN_LEVEL1)
                    ],
                    [
                        new BigWinStep(GameConfig.instance.WIN_RATIOS.bigWin[0], GameConfig.instance.WIN_RATIOS.bigWin[1], false, SpacierArcadeSoundConfig.instance.BIG_WIN_LEVEL2)
                    ],
                    [
                        new BigWinStep(GameConfig.instance.WIN_RATIOS.bigWin[1], GameConfig.instance.WIN_RATIOS.bigWin[2], false,  SpacierArcadeSoundConfig.instance.BIG_WIN_LEVEL3)
                    ],
                    [
                        new WinEnd(),
                    ],
                    [
                        new BetWayWinUS(),
                    ]
                ]

            },
            FREESPIN : {
                idle : [
                    new SAZeroBet()
                ],
                idleLoop : [],
                starting : [
                    new FreespinSpinStart(),
                    new ReelStart(0, 0),
                    new ReelStart(1, 0.04),
                    new ReelStart(2, 0.08),
                    new ReelStart(3, 0.12),
                    new ReelStart(4, 0.16)
                ],
                stoppable : [
                    new FreeSpinWildAttention(),
                    new ReelStop(0),
                    new SymbolOverlays(0),

                    new ReelStop(1),
                    new SymbolOverlays(1),

                    new ReelStop(2),
                    new SymbolOverlays(2),

                    new ReelStop(3),
                    new SymbolOverlays(3),

                    new ReelStop(4),
                    new SpinStop()
                ],
                skippable : [
                    [
                        new ScatterRetrigger()
                    ],
                    [
                        new SAOverlayPresentation(),
                        new NormalWin(),
                        new BigWinStep(GameConfig.instance.WIN_RATIOS.normalWin[0], GameConfig.instance.WIN_RATIOS.bigWin[0], true, SpacierArcadeSoundConfig.instance.BIG_WIN_LEVEL1)
                    ],
                    [
                        new BigWinStep(GameConfig.instance.WIN_RATIOS.bigWin[0], GameConfig.instance.WIN_RATIOS.bigWin[1], false, SpacierArcadeSoundConfig.instance.BIG_WIN_LEVEL2)
                    ],
                    [
                        new BigWinStep(GameConfig.instance.WIN_RATIOS.bigWin[1], GameConfig.instance.WIN_RATIOS.bigWin[2], false, SpacierArcadeSoundConfig.instance.BIG_WIN_LEVEL3)
                    ],
                    [
                        new WinEnd(),
                    ],
                    [
                        new BetWayWinUS(),
                    ]
                ]
            },
            FREESPIN_WIN_RESPIN : {
                idle : [
                    new SAZeroBet()
                ],
                idleLoop : [],
                starting : [
                    new GameRestoreHandling(),
                    new SpinStart(),
                    new ReelStart(0, 0),
                    new ReelStart(1, 0),
                    new ReelStart(2, 0),
                    new ReelStart(3, 0),
                    new ReelStart(4, 0),
                ],
                stoppable : [
                    new FSProlongSpin(2),
                    new ReelStopPresentations(0),
                    new SymbolOverlays(0),

                    new ReelStopPresentations(1),
                    new SymbolOverlays(1),

                    new ReelStopPresentations(2),
                    new SymbolOverlays(2),

                    new ReelStopPresentations(3),
                    new SymbolOverlays(3),

                    new ReelStopPresentations(4),
                    new SpinStop()
                ],
                skippable : [
                    [
                        new ScatterRetrigger()
                    ],
                    [
                        new SAOverlayPresentation(),
                        new NormalWin(),
                        new BigWinStep(GameConfig.instance.WIN_RATIOS.normalWin[0], GameConfig.instance.WIN_RATIOS.bigWin[0], true, SpacierArcadeSoundConfig.instance.BIG_WIN_LEVEL1)
                    ],
                    [
                        new BigWinStep(GameConfig.instance.WIN_RATIOS.bigWin[0], GameConfig.instance.WIN_RATIOS.bigWin[1], false, SpacierArcadeSoundConfig.instance.BIG_WIN_LEVEL2)
                    ],
                    [
                        new BigWinStep(GameConfig.instance.WIN_RATIOS.bigWin[1], GameConfig.instance.WIN_RATIOS.bigWin[2], false, SpacierArcadeSoundConfig.instance.BIG_WIN_LEVEL3)
                    ],
                    [
                        new WinEnd(),
                    ],
                    [
                        new BetWayWinUS(),
                    ]
                ]
            }
        }


    };

    GAME_FEATURE_CREATOR: () => void = () => {
        SpacierArcadeGameModuleConfig.gameTweakerTest = new GameTweakerTest();
        SpacierArcadeGameModuleConfig.spacierArcadeOverlayView = new SpacierArcadeOverlayView();
        SpacierArcadeGameModuleConfig.spacierMultiplierAddupController = new SAMultiplierAddupController();
        SpacierArcadeGameModuleConfig.saReelAttentionView = new SAReelAttentionView();
        SpacierArcadeGameModuleConfig.saFreespinReelAttentionView = new SAFreespinReelAttentionView();
        SpacierArcadeGameModuleConfig.saScatterAttentionView = new SAScatterAttentionView();
        SpacierArcadeGameModuleConfig.saWinCountUp = new SpacierArcadeInitialWinCountUp();
        SpacierArcadeGameModuleConfig.saIndividualWinCountUp = new SAIndividualWinCountUp();
        SpacierArcadeGameModuleConfig.saBigWinView = new WinTextView();
        SpacierArcadeGameModuleConfig.saCountupView = new CountUpView();
        SpacierArcadeGameModuleConfig.saInitialWinPresentation = new SAInitialWinPresentation();

        StageManager.legacyScaling = false;
        SpacierArcadeGameModuleConfig.background = new SABackground({
            layer: SpacierArcadeGameConfig.instance.LAYERS.BACKGROUND.name,
            backgroundImages: {
                NORMAL: {image: SpacierArcadeGameAssets.MAIN_GAME_BACKGROUND, offset: new PIXI.Point(-480, -480)},
                FREESPIN: {image: SpacierArcadeGameAssets.FREESPIN_BACKGROUND, offset: new PIXI.Point(-480, -480)},
                FREESPIN_WIN_RESPIN: {image: SpacierArcadeGameAssets.FREESPIN_BACKGROUND, offset: new PIXI.Point(-480, -480)},
                WILD_RESPIN: {image: SpacierArcadeGameAssets.MAIN_GAME_BACKGROUND, offset: new PIXI.Point(-480, -480)}
            },
            stretch: false
        });

        SpacierArcadeGameModuleConfig.featurePrice = new FeaturePrice();
    };

    public static instance: SpacierArcadeGameModuleConfig = new SpacierArcadeGameModuleConfig();
    public static spacierArcadeOverlayView:SpacierArcadeOverlayView;
    private static gameTweakerTest: GameTweakerTest;
    private static background: StillImageBackground;
    public static spacierMultiplierAddupController: SAMultiplierAddupController;
    public static saReelAttentionView: SAReelAttentionView;
    public static saFreespinReelAttentionView: SAFreespinReelAttentionView;
    public static saScatterAttentionView: SAScatterAttentionView;
    public static saWinCountUp: SpacierArcadeInitialWinCountUp;
    public static saIndividualWinCountUp: SAIndividualWinCountUp;
    public static saBigWinView:WinTextView;
    public static saCountupView:CountUpView;
    public static saInitialWinPresentation:SAInitialWinPresentation;
    public static featurePrice: FeaturePrice;
}